<template>
  <div class="card">
    <div class="card-body">
      <router-link
        class="close"
        :to="'/' + 'products/' + $i18n.locale"
      ></router-link>
      <h5 class="create-title">{{ $t('addNewProduct') }}</h5>
      <form @submit.prevent="createProduct">
        <div>
          <p class="inputLabel">{{ $t('productName') }}</p>
          <input
            class="field"
            v-model="product.name"
            type="text"
            :placeholder="$t('prodNameExample')"
            :class="{ 'error-boarder': $v.product.name.$error }"
            @blur="$v.product.name.$touch()"
          />
          <!--Form validation-->
          <template v-if="$v.product.name.$error">
            <p v-if="!$v.product.name.required" class="errorMessage">
              {{ $t('prodNameReq') }}
            </p>
          </template>
          <template v-if="$v.product.name.$error">
            <p v-if="!$v.product.name.maxLength" class="errorMessage">
              {{ $t('productNameMaxLength') }}
            </p>
          </template>
          <template v-if="$v.product.name.$error">
            <p v-if="!$v.product.name.minLength" class="errorMessage">
              {{ $t('productNameMinLength') }}
            </p>
          </template>
          <multiselect
            v-model="product.prodCat"
            :options="categoryNames"
            :searchable="false"
            :close-on-select="true"
            track-by="id"
            label="name"
            :placeholder="$t('selectProdCat')"
            :show-labels="false"
            @select="nameSelect"
            :class="{ 'error-boarder': $v.product.prodCat.$error }"
            @blur="$v.product.prodCat.$touch()"
            @input="$v.product.prodCat.$touch()"
          ></multiselect>
          <!--Form validation-->
          <template v-if="$v.product.prodCat.$error">
            <p v-if="!$v.product.prodCat.required" class="errorMessage">
              {{ $t('prodCatReq') }}
            </p>
          </template>
          <br />
        </div>
        <!--Form validation-->
        <template v-if="$v.product.prodCat.$error">
          <p v-if="!$v.product.prodCat.required" class="errorMessage">
            {{ $t('prodCatReq') }}
          </p>
        </template>

        <!-- <multiselect
          v-model="product.supplier"
          :options="supplierNames"
          :searchable="true"
          :close-on-select="true"
          track-by="id"
          label="name"
          :placeholder="$t('selectSupplier')"
          :show-labels="false"
          @select="nameSelect"
          :class="{ error: $v.product.supplier.$error }"
          @input="$v.product.supplier.$touch()"
        ></multiselect>
        <br /> -->

        <!--Form validation-->
        <!-- <template v-if="$v.product.supplier.$error">
          <p v-if="!$v.product.supplier.required" class="errorMessage">
            {{ $t('supplierReq') }}
          </p>
        </template> -->

        <b-form-textarea
          class="field form-control"
          aria-label="With textarea"
          v-model="product.description"
          :state="product.description.length <= 300"
          type="text"
          :placeholder="$t('prodDesc50')"
          :class="{ 'error-boarder': $v.product.description.$error }"
          rows="6"
          @blur="$v.product.description.$touch()"
        ></b-form-textarea>
        <!--Form validation-->
        <template v-if="$v.product.description.$error">
          <p v-if="!$v.product.description.required" class="errorMessage">
            {{ $t('prodDescReq') }}
          </p>
        </template>
        <template v-if="$v.product.description.$error">
          <p v-if="!$v.product.description.maxLength" class="errorMessage">
            {{ $t('descMaxLength') }}
          </p>
        </template>

        <input
          class="field"
          v-model="product.price"
          type="number"
          maxlength="10"
          min="0.5"
          step=".01"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          :placeholder="$t('sellingPrice')"
          :class="{ 'error-boarder': $v.product.price.$error }"
          @blur="$v.product.price.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.product.price.$error">
          <p v-if="!$v.product.price.required" class="errorMessage">
            {{ $t('sellingPriceReq') }}
          </p>
        </template>

        <input
          class="field"
          v-model="product.purchase_price"
          type="number"
          min="0"
          maxlength="10"
          step=".01"
          :placeholder="$t('purchasePrice')"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          :class="{ 'error-boarder': $v.product.purchase_price.$error }"
          @blur="$v.product.purchase_price.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.product.purchase_price.$error">
          <p v-if="!$v.product.purchase_price.required" class="errorMessage">
            {{ $t('purchasePriceReq') }}
          </p>
        </template>

        <!-- <input
          class="field"
          v-model="product.stock_general"
          type="number"
          maxlength="4"
          :placeholder="$t('overallStock')"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          :class="{ 'error-boarder': $v.product.stock_general.$error }"
          @blur="$v.product.stock_general.$touch()"
        />

        <template v-if="$v.product.stock_general.$error">
          <p v-if="!$v.product.stock_general.required" class="errorMessage">
            {{ $t('overallStockReq') }}
          </p>
        </template> -->

        <!------------------------------DELIVERY DETAILS ----------------------- -->
        <div id="selector">
          <div class="checkbox">
            <label class="form-control2">
              <input
                type="checkbox"
                v-model="product.shippable"
                @change="addShippingSection"
              />
              {{ $t('offerGuestDelivery') }}
            </label>
          </div>
          <div v-show="product.shippable">
            <p class="titlePickUp">{{ $t('packageDetails') }}</p>
            <p class="limitPickUp">{{ $t('packageLimits') }}</p>
            <input
              v-model="shipping_details.pkg_weight"
              class="field"
              type="number"
              min="1"
              step="1"
              maxlength="3"
              :placeholder="$t('weightkg')"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              :class="{
                'error-boarder': $v.shipping_details.pkg_weight.$error
              }"
              @blur="$v.shipping_details.pkg_weight.$touch()"
              @input="preventFirstZero($event)"
            />
            <input
              v-model="shipping_details.pkg_width"
              class="field"
              type="number"
              maxlength="3"
              min="1"
              step="1"
              :placeholder="$t('widthcm')"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              :class="{ 'error-boarder': $v.shipping_details.pkg_width.$error }"
              @blur="$v.shipping_details.pkg_width.$touch()"
              @input="preventFirstZero($event)"
              @change="checkPackageDimensions"
            />
            <input
              v-model="shipping_details.pkg_height"
              class="field"
              type="number"
              min="1"
              step="1"
              maxlength="3"
              :placeholder="$t('heightcm')"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              :class="{
                'error-boarder': $v.shipping_details.pkg_height.$error
              }"
              @blur="$v.shipping_details.pkg_height.$touch()"
              @input="preventFirstZero($event)"
              @change="checkPackageDimensions"
            />
            <input
              v-model="shipping_details.pkg_length"
              class="field"
              type="number"
              min="1"
              step="1"
              maxlength="3"
              :placeholder="$t('lengthcm')"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              :class="{
                'error-boarder': $v.shipping_details.pkg_length.$error
              }"
              @blur="$v.shipping_details.pkg_length.$touch()"
              @input="preventFirstZero($event)"
            />
            <p class="titlePickUp">{{ $t('pickupDetails') }}</p>
            <input
              v-model="shipping_address.pickup_address"
              ref="autocomplete"
              id="address"
              class="field"
              type="text"
              maxlength="40"
              :placeholder="$t('address')"
              :class="{
                'error-boarder': $v.shipping_address.pickup_address.$error
              }"
              @blur="$v.shipping_address.pickup_address.$touch()"
            />
            <input
              v-model="shipping_address.pickup_postal_code"
              class="field"
              type="text"
              maxlength="10"
              :placeholder="$t('postalCode')"
              :class="{
                'error-boarder': $v.shipping_address.pickup_postal_code.$error
              }"
              @blur="$v.shipping_address.pickup_postal_code.$touch()"
            />
            <input
              v-model="shipping_address.pickup_city"
              class="field"
              type="text"
              maxlength="20"
              :placeholder="$t('city')"
              :class="{
                'error-boarder': $v.shipping_address.pickup_city.$error
              }"
              @blur="$v.shipping_address.pickup_city.$touch()"
            />
            <p class="selectCountry">{{ $t('selectCountry') }}</p>
            <country-select
              :country="shipping_address.pickup_country"
              v-model="shipping_address.pickup_country"
              class="field inputStyle"
              topCountry="SI"
              :placeholder="$t('country')"
              :countryName="true"
              :autocomplete="true"
              id="country"
              :class="{
                'error-boarder': $v.shipping_address.pickup_country.$error
              }"
              @blur="$v.shipping_address.pickup_country.$touch()"
            />
            <input
              v-model="shipping_address.additional_information"
              class="field"
              type="text"
              :placeholder="$t('pickUpInfo')"
            />
          </div>
        </div>
        <!-----------------------------------------end of DELIVERY DETAILS -------------------------------------->

        <div id="selector2">
          <div class="checkbox">
            <label class="form-control2">
              <input
                type="checkbox"
                v-model="product.wholesalable"
                :true-value="1"
                :false-value="0"
              />
              {{ $t('offerToOtherClients') }}
            </label>
          </div>
          <div v-show="product.wholesalable">
            <p class="titlePickUp">{{ $t('wholesaleDetails') }}</p>
            <div class="formInput">
              <input
                class="field"
                :placeholder="$t('wholesale_price')"
                v-model="wholesale_details.wholesale_price"
                type="number"
                maxlength="10"
                step=".01"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                :class="{
                  'error-boarder': $v.wholesale_details.wholesale_price.$error
                }"
                @blur="$v.wholesale_details.wholesale_price.$touch()"
              />
              <template v-if="$v.wholesale_details.wholesale_price.$error">
                <div
                  v-if="!$v.wholesale_details.wholesale_price.required"
                  class="errorMessage"
                >
                  {{ $t('wholesale_price_req') }}
                </div>
              </template>
            </div>
            <div class="formInput">
              <input
                class="field"
                v-model="wholesale_details.sugg_selling_price"
                :placeholder="$t('sugg_selling_price')"
                type="number"
                maxlength="10"
                step=".01"
                :class="{
                  'error-boarder':
                    $v.wholesale_details.sugg_selling_price.$error
                }"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                @blur="$v.wholesale_details.sugg_selling_price.$touch()"
              />
              <template v-if="$v.wholesale_details.sugg_selling_price.$error">
                <div
                  v-if="!$v.wholesale_details.sugg_selling_price.required"
                  class="errorMessage"
                >
                  {{ $t('sugg_selling_price_req') }}
                </div>
              </template>
            </div>
            <div class="formInput">
              <input
                class="field"
                :placeholder="$t('moq')"
                v-model="wholesale_details.moq"
                type="text"
                maxlength="25"
                :class="{ 'error-boarder': $v.wholesale_details.moq.$error }"
                @blur="$v.wholesale_details.moq.$touch()"
              />
              <template v-if="$v.wholesale_details.moq.$error">
                <div
                  v-if="!$v.wholesale_details.moq.required"
                  class="errorMessage"
                >
                  {{ $t('moq_req') }}
                </div>
              </template>
            </div>
            <div class="formInput">
              <b-form-textarea
                class="field form-control"
                aria-label="With textarea"
                v-model="wholesale_details.info_pack_sizes"
                :state="wholesale_details.info_pack_sizes.length <= 300"
                type="text"
                :placeholder="$t('infoPackSizes')"
                :class="{
                  'error-boarder': $v.wholesale_details.info_pack_sizes.$error
                }"
                rows="6"
                @blur="$v.wholesale_details.info_pack_sizes.$touch()"
              ></b-form-textarea>
            </div>
          </div>
        </div>

        <!-- <div class="optionalData">
          <p class="optional">{{ $t('optional') }}</p>
          <input
            class="field bgOptional"
            v-model="product.ean_code"
            type="number"
            :placeholder="$t('EANcode')"
            :class="{ error: $v.product.ean_code.$error }"
            @blur="$v.product.ean_code.$touch()"
          />
        </div> -->

        <button
          class="add-btn"
          type="submit"
          buttonClass="-fill-gradient"
          :disabled="$v.$invalid || (product.shippable && !isDimensionValid)"
        >
          {{ $t('add') }}
        </button>
        <p v-if="$v.anyError" class="errorMessage">
          {{ $t('fillInReq') }}
        </p>
      </form>
      <sweet-modal icon="success" ref="modalSuccess">
        {{ $t('addedProductConf') }}
      </sweet-modal>
      <sweet-modal icon="error" title="Oh nooo…" ref="modalError">
        {{ $t('errorMsg') }}
        <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NProgress from 'nprogress'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import ShippingService from '@/services/ShippingService'
// import countryLookup from 'country-code-lookup'

export default {
  name: 'productCreate',
  metaInfo() {
    return {
      title: this.$i18n.t('addProduct')
    }
  },
  data() {
    return {
      categoryNames: [],
      categoryName: [],
      supplierNames: [],
      supplierName: [],
      supplier: [],
      prodCat: [],
      product: this.createFreshProductObject(),
      selectedFile: null,
      shippable: false,
      wholesalable: 0,
      widget: null,
      shipping_details: {
        pkg_weight: '',
        pkg_height: '',
        pkg_length: '',
        pkg_width: ''
      },
      shipping_address: {
        pickup_address: '',
        pickup_city: '',
        pickup_postal_code: '',
        // pickup_country: '',
        additional_information: ''
      },
      wholesale_details: {
        wholesale_price: '',
        sugg_selling_price: '',
        moq: '',
        info_pack_sizes: ''
      },
      isDimensionValid: false
    }
  },
  validations() {
    const validationObject = {}
    validationObject.product = {
      prodCat: { required },
      supplier: {},
      name: { required, maxLength: maxLength(35), minLength: minLength(3) },
      description: { required, maxLength: maxLength(300) },
      purchase_price: { required },
      price: { required },
      ean_code: {},
      // stock_general: {}
    }
    if (this.product.shippable === true) {
      ;(validationObject.shipping_details = {
        pkg_weight: { required },
        pkg_height: { required },
        pkg_length: { required },
        pkg_width: { required }
      }),
        (validationObject.shipping_address = {
          pickup_address: { required },
          pickup_postal_code: { required },
          pickup_city: { required },
          pickup_country: { required },
          additional_information: {}
        })
    } else {
      ;(validationObject.shipping_details = {
        pkg_weight: {},
        pkg_height: {},
        pkg_length: {},
        pkg_width: {}
      }),
        (validationObject.shipping_address = {
          pickup_address: {},
          pickup_postal_code: {},
          pickup_city: {},
          pickup_country: {},
          additional_information: {}
        })
    }
    if (this.product.wholesalable === 1) {
      validationObject.wholesale_details = {
        wholesale_price: { required },
        sugg_selling_price: { required },
        moq: { required },
        info_pack_sizes: {}
      }
    } else {
      validationObject.wholesale_details = {
        wholesale_price: {},
        sugg_selling_price: {},
        moq: {},
        info_pack_sizes: {}
      }
    }
    return validationObject
  },
  mounted() {
    axios
      .all([
        axios.get(`${process.env.VUE_APP_API_URL}/productCategories`),
        axios.get(`${process.env.VUE_APP_API_URL}/suppliers`)
      ])
      .then(
        axios.spread((productCategoriesRes, suppliersRes) => {
          ;(this.categoryNames = productCategoriesRes.data),
            (this.supplierNames = suppliersRes.data)
        })
      )
  },
  methods: {
    addShippingSection() {
      const self = this
      setTimeout(() => {
        self.widget = new window.google.maps.places.Autocomplete(
          self.$refs.autocomplete,
          { types: ['geocode'] }
        )
        self.widget.addListener('place_changed', () => {
          self.setValues()
        })
      }, 100)
    },
    setValues() {
      this.shipping_address.pickup_postal_code = ''
      this.shipping_address.pickup_city = ''
      // this.shipping_address.pickup_country = ''
      this.shipping_address.pickup_address = this.$refs.autocomplete.value
      const placeDetails = this.widget.getPlace()
      placeDetails.address_components.forEach(addressComp => {
        if (addressComp.types.includes('locality'))
          this.shipping_address.pickup_city = addressComp.long_name
        if (addressComp.types.includes('postal_code'))
          this.shipping_address.pickup_postal_code = addressComp.long_name
        // if(addressComp.types.includes('country')) this.shipping_address.pickup_country = addressComp.long_name;
      })
    },
    async validateAddress() {
      const validationResponse = await ShippingService.getValidateAddress({
        StreetAddress: this.shipping_address.pickup_address,
        City: this.shipping_address.pickup_city,
        PostalCode: this.shipping_address.pickup_postal_code,
        CountryCode: 'SI'
      })
      if (validationResponse.data.status === 'VALID') return true
      return false
    },
    async createProduct() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        if (this.product.purchase_price === '')
          this.product.purchase_price = null
        const validAddress = true
        if (validAddress) {
          this.$store
            .dispatch('product/createProduct', {
              ...this.product,
              shipping_details: {
                ...this.shipping_details,
                ...this.shipping_address
              },
              wholesale_details: this.wholesale_details
            })
            .then(response => {
              if (response.message) {
                alert(response.message)
              } else {
                // this.$refs.imageUpload.onSubmit(response.insertId)
                this.$router.push({
                  name: 'product',
                  params: { productId: response.insertId }
                }) // automatically redirect to login when user click "register"//
                NProgress.done()
                this.product = this.createFreshProductObject()
              }
            })
            .catch(() => {
              this.$refs.modalError.open()
              NProgress.done()
            })
        } else {
          alert('Please enter valid address')
        }
      }
    },
    createFreshProductObject() {
      const client = this.$store.state.client.client
      const id = Math.floor(Math.random() * 1000000)

      return {
        id: id,
        supplier: '',
        client_id: client,
        prodCat: '',
        name: '',
        description: '',
        purchase_price: '',
        price: '',
        ean_code: '',
        // stock_general: '',
        shippable: false,
        wholesalable: 0,
        selfService: false,
        height_mm: 0,
        width_mm: 0,
        length_mm: 0,
        weight_g: 0
      }
    },
    nameSelect(option) {
      this.categoryNames.name = option.name
      this.supplierNames.name = option.name
    },
    preventFirstZero(event) {
      if (event.target.value.charAt(0) == '0') {
        event.target.value = event.target.value.slice(1)
      }
    },
    checkPackageDimensions() {
      this.isDimensionValid = false
      const width = this.shipping_details.pkg_width
      const height = this.shipping_details.pkg_height
      if (width && height) {
        if ((height >= 11 && width >= 15) || (width >= 11 && height >= 15)) {
          this.isDimensionValid = true
          return
        }
        if (height >= 11 && width < 15) {
          this.shipping_details.pkg_width = ''
        } else if (width >= 11 && height < 15) {
          this.shipping_details.pkg_height = ''
        } else if (width <= 11 && height <= 11) {
          this.shipping_details.pkg_width = ''
          this.shipping_details.pkg_height = ''
        }
        alert(this.$t('packageLimits'))
      } else if (width && width < 11) {
        this.shipping_details.pkg_width = ''
        alert(this.$t('packageLimits'))
      } else if (height && height < 11) {
        this.shipping_details.pkg_height = ''
        alert(this.$t('packageLimits'))
      }
    }
  }
}
</script>

<style scoped>
@import '../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
.field {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-bottom: 1em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

.bgOptional {
  background: rgb(252, 250, 250);
}

.titlePickUp {
  text-transform: uppercase;
  font-weight: 600;
  margin: 5px;
}

.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 60px 30px 60px;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  margin-top: 1em;
  color: var(--bg);
}

.error-boarder {
  border: 2px solid var(--primaryDark);
}

form {
  width: 45%;
}

button.action:hover {
  opacity: 0.9;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.close {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.card-body {
  color: #454655;
}

.inputLabel {
  text-align: left;
  margin-bottom: 0px;
}

.bgOptional {
  background: rgb(252, 250, 250);
  border: none !important;
}

.inputStyle {
  margin-bottom: 24px;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.add-btn {
  margin-top: 1em;
  background: var(--primaryDark);
  color: var(--bright);
  letter-spacing: 8px;
  border-radius: 5px;
  width: 200px;
  text-transform: uppercase;
  padding: 15px;
  font-size: 1.6em;
}

.create-title {
  font-weight: 600;
  font-size: 2.5em;
  margin-top: 20px;
}
p {
  text-align: left;
}

textarea.form-control.is-valid:focus {
  border: 2px solid black !important;
  box-shadow: none;
}

/** Custom CheckBox Style*/

.form-control2 {
  font-size: 1.2em;
  font-weight: bold;
  text-align: left;
  display: grid;
  grid-template-columns: 1em auto;
  gap: 0.5em;
}

.form-control2 + .form-control {
  margin-top: 1em;
}

.form-control2--disabled {
  color: var(--grey);
  cursor: not-allowed;
}

input[type='checkbox'] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--bright);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  padding: 0px !important;
  display: grid;
  place-content: center;
}

input[type='checkbox']::before {
  content: '';
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--primary);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type='checkbox']:checked::before {
  transform: scale(1);
}

input[type='checkbox']:focus {
  outline: max(2px, 0.15em) solid currentColor;
  outline-offset: max(2px, 0.15em);
}

input[type='checkbox']:disabled {
  --primary: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}

/** */

@media screen and (min-width: 560px) {
  .close {
    display: none;
  }
}

textarea.form-control {
  width: 100%;
  height: 100px;
}

@media screen and (max-width: 560px) {
  .field {
    margin-bottom: 15px;
  }
  textarea.form-control {
    width: 100%;
    height: 200px;
  }
  form {
    width: 100%;
    padding: 10px;
  }
  .optionalData {
    padding: 0 20px 10px 20px;
  }
  .create-title {
    font-size: 1.8em;
    margin-top: 60px;
    margin-bottom: 20px;
  }
  .add-btn {
    margin-top: 50px;
    width: 100%;
    letter-spacing: 6px;
    padding: 10px;
    font-size: 1.5em;
  }
}

.error {
  background-color: none !important;
  border-color: none !important;
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}
</style>

<style>
/* global styles */
.pac-container {
  z-index: 1042 !important;
}
</style>
